import { UntypedFormControl, Validators } from '@angular/forms';

/**
 *
 * @param requiredWhenFn Function to evaluate if
 * field should be required.
 */
export function requiredWhen(requiredWhenFn: () => boolean) {
  return function(control: UntypedFormControl) {
    setTimeout(() => control.updateValueAndValidity(), 5);
    if (requiredWhenFn() === false) {
      return null;
    }
    return Validators.required(control);
  };
}
